<template>
  <v-main>
    <v-app-bar app flat light color="white">
      <AppbarBackIcon />
      <v-toolbar-title class="font-weight-bold">
        <span>价格表</span>
      </v-toolbar-title>
    </v-app-bar>
    <v-container fluid>
      <v-container fluid class="price-tier" v-for="(tier, index) in tier_s" :key="index">
        <v-row dense align="center">
          <v-col cols="8">
            <v-text-field dense hide-details type="number" prefix="级别" v-model="tier.key"></v-text-field>
          </v-col>
          <v-col offset="1">
            <v-btn class="price-tier-delete" icon @click="onDeleteTier(index)">
              <v-icon>{{ mdiDelete }}</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row dense align="center" v-for="currency in currencyList" :key="currency">
          <v-col cols="7" offset="1">
            <InputMoneyField
              dense
              hide-details
              :prefix="currency"
              :currency="currency"
              :value="priceOf(index, currency)"
              @input="onUpdatePrice($event, index, currency)"
            />
          </v-col>
        </v-row>
      </v-container>
      <v-btn class="mt-4" depressed @click="onAddTier">
        <v-icon>{{ mdiPlus }}</v-icon>
        <span>添加级别</span>
      </v-btn>
      <v-btn width="100%" color="primary" class="mt-16" @click="onSave">保存</v-btn>
    </v-container>
  </v-main>
</template>

<script>
import _ from 'lodash'
import Vue from 'vue'
import { mdiDelete, mdiPlus } from '@mdi/js'
import { homeStore } from '@/store/home'
import { priceTableStore } from '@/store/priceTable'
import AppbarBackIcon from '@/components/AppbarBackIcon.vue'
import InputMoneyField from '@/components/InputMoneyField.vue'

export default {
  components: { AppbarBackIcon, InputMoneyField },
  data() {
    return {
      mdiDelete,
      mdiPlus,
      currencyList: ['CNY', 'USD', 'BTC'],
      tier_s: [],
    }
  },
  computed: {},
  async mounted() {
    await homeStore.doLoad()
    this.sync_tier_s()
  },
  methods: {
    sync_tier_s() {
      this.tier_s = this.get_tier_s(priceTableStore.tier_d)
      if (this.tier_s.length <= 0) {
        this.onAddTier()
      }
    },
    get_tier_s(tier_d) {
      tier_d = JSON.parse(JSON.stringify(tier_d))
      let tier_s = Object.entries(tier_d).map(([key, item]) => {
        return {
          key: _.parseInt(key),
          price_d: item.price_d,
        }
      })
      return _.sortBy(tier_s, ['key'])
    },
    priceOf(index, currency) {
      let priceItem = this.tier_s[index].price_d[currency]
      return priceItem?.price
    },
    onDeleteTier(index) {
      this.tier_s.splice(index, 1)
    },
    onAddTier() {
      let key = 0
      for (let tier of this.tier_s) {
        let tierKey = _.parseInt(tier.key)
        if (tierKey > key) {
          key = tierKey
        }
      }
      this.tier_s.push({ key: key + 1, price_d: {} })
    },
    onUpdatePrice(price, index, currency) {
      let price_d = this.tier_s[index].price_d
      Vue.set(price_d, currency, { price })
    },
    async onSave() {
      const tier_d = {}
      this.tier_s.forEach(tier => {
        if (!_.isNil(tier.key) && tier.key !== '') {
          let price_d = {}
          Object.entries(tier.price_d).forEach(([currency, item]) => {
            if (!_.isNil(item.price) && item.price !== '') {
              price_d[currency] = item
            }
          })
          tier_d[tier.key] = { price_d }
        }
      })
      await priceTableStore.doUpsert({ tier_d })
      this.$toasted.success('保存成功')
      this.sync_tier_s()
    },
  },
}
</script>

<style lang="less" scoped></style>
